export default "__VITE_ASSET__1a340a46__"